import { SectionHeader } from "@/components/ui/SectionHeader";
import { InfoCard } from "@/components/ui/InfoCard";
import { cn } from "@/lib/utils";

const CHAINS = [
  {
    name: "Ethereum",
    description:
      "最も広く採用されたスマートコントラクトプラットフォーム。高いセキュリティと流動性を持つメインネットでの ステーブルコイン 発行・送付に対応します。",
    tag: "Mainnet",
  },
  {
    name: "Arbitrum",
    description:
      "EVM 互換の代表的な L2。既存の Ethereum エコシステムと高い互換性を保ちつつ、低コストでの ステーブルコイン 送付・運用に対応します。",
    tag: "Layer 2",
  },
  {
    name: "Polygon",
    description:
      "低コスト・高速な L2 ソリューション。大量の Intent / Redemption を効率的に処理し、ガス代を大幅に削減できます。",
    tag: "Layer 2",
  },
  {
    name: "Optimism",
    description:
      "EVM 互換の L2。安定したエコシステムと開発体験で、低コスト・高速な ステーブルコイン 発行/送付フローに対応します。",
    tag: "Layer 2",
  },
  {
    name: "Avalanche",
    description:
      "高スループットと即時ファイナリティを実現する L1。エンタープライズ用途に適した高性能ネットワークです。",
    tag: "Layer 1",
  },
  {
    name: "Arc",
    description:
      "用途に応じたネットワーク選択肢として、Arc を含む EVM 互換チェーンに対応します。",
    tag: "EVM",
  },
] as const;

export function MbscChains() {
  return (
    <section className="border-t border-border/60 bg-muted/20 px-6 py-20 md:px-12">
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          eyebrow="Supported Chains"
          title="EVM 互換チェーンを幅広くカバー。"
          description="Intent 作成時に issueChain を指定するだけでチェーンを選択できます。RPC やチェーンアダプター（IChainAdapter）の切り替えは MBSC が内部で処理するため、事業者側の追加開発は不要です。"
        />
        <div className={cn("mt-12 grid gap-6 sm:grid-cols-3")}>
          {CHAINS.map((chain) => (
            <InfoCard
              key={chain.name}
              title={chain.name}
              tag={chain.tag}
              description={chain.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
